import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';

import { Text } from '../atom/Text';
import EventReviewContestIcon from '../../../lib/image/event/EventReviewContestIcon';
import ThemeStyle from '../../../lib/style/ThemeStyle';
import { Flex } from '../atom/Layout';

export const StickeyTabBar = ({ tabList = [{ path: '', label: '' }] }) => {
  const [activeTab, setActiveTab] = useState(tabList[0].label);

  return (
    <StickyMenuBar>
      {tabList.map((item, index) => (
        <Flex column style={{ position: 'relative' }} key={index}>
          {item.label === '리뷰' && (
            <Flex style={{ position: 'absolute', top: '-2.4rem' }}>
              <EventReviewContestIcon />
            </Flex>
          )}
          <Link
            to={item.path}
            spy={true}
            smooth={true}
            duration={500}
            offset={-120}
            onSetActive={() => setActiveTab(item.label)}
          >
            <Text
              weight="medium"
              color={activeTab === item.label ? 'orangePink' : 'darkest'}
              style={{
                cursor: 'pointer',
                padding: '0.5rem',
                borderBottom:
                  activeTab === item.label
                    ? `3px solid ${ThemeStyle.color.orangePink}`
                    : 'none',
              }}
            >
              {item.label}
            </Text>
          </Link>
        </Flex>
      ))}
    </StickyMenuBar>
  );
};

const StickyMenuBar = styled.div`
  position: sticky;
  top: 2.875rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  min-height: 2.5rem;
  border-bottom: ${(props) => `1px solid ${props.theme.color.pinkishGrey}`};
  background-color: ${(props) => props.theme.background.white};
  z-index: 10;
`;
